import { render, staticRenderFns } from "./Toasts.vue?vue&type=template&id=b5b49444&"
import script from "./Toasts.vue?vue&type=script&lang=js&"
export * from "./Toasts.vue?vue&type=script&lang=js&"
import style0 from "./Toasts.vue?vue&type=style&index=0&id=b5b49444&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports